


import { BaseAjaxSave } from "../../../../assets/js/common/shared_service";

export default class UpdateDeliveryNote{

    constructor(){
        this.deliveryNoteUpdateForm = document.querySelector('#deliveryNoteUpdateForm');
        if(!this.deliveryNoteUpdateForm) return;
        //this.events();
    }

    events(){
        let timer;
        const saveForm = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                BaseAjaxSave({
                    target: this.deliveryNoteUpdateForm,
                    preventDefault: () => {}
                });
            }, 300);
        };
        this.deliveryNoteUpdateForm.addEventListener('change', saveForm);
        $(this.deliveryNoteUpdateForm).find('#id_customer').on('select2:select', saveForm);
        $(this.deliveryNoteUpdateForm).find('#id_date_created').on('changeDate', saveForm);
    }

} 